import {
    getDriverContent,
    getHomeContent,
    getPartnerContent,
    getVehicleContent,
    getVehiclePartnerContent,
    getDriverPartnerContent
} from "../API/ContentAPI";
import { useQuery } from "react-query";

export const useGetHomeContent = () => {
    return useQuery({
        queryKey: ["home-content"],
        queryFn: () => getHomeContent(),
    });
};

export const useGetPartnerContent = () => {
    return useQuery({
        queryKey: ["partner-content"],
        queryFn: () => getPartnerContent(),
    });
};

export const useGetVehicleContent = () => {
    return useQuery({
        queryKey: ["vehicle-content"],
        queryFn: () => getVehicleContent(),
    });
};

export const useGetVehiclePartnerContent = () => {
    return useQuery({
        queryKey: ["vehicle-partner-content"],
        queryFn: () => getVehiclePartnerContent(),
    });
};

export const useGetDriverPartnerContent = () => {
    return useQuery({
        queryKey: ["driver-partner-content"],
        queryFn: () => getDriverPartnerContent(),
    });
};

export const useGetDriverContent = () => {
    return useQuery({
        queryKey: ["driver-content"],
        queryFn: () => getDriverContent(),
    });
};
